<template>
  <BaseCard
    :heading="$t('employee.profile.portfolio')"
    gray
  >
    <BaseGallery
      v-model="galleryImages"
      :maxLength="9"
      cloudinaryPreset="resource-portfolio"
      :imaginaryCategory="imaginaryCategory"
      @upload-started="clearUploadError"
      @upload-error="handleUploadError"
    />
    <BaseAlert
      v-if="uploadError"
      color="error"
      :text="$t('global.gallery.upload_failed')"
      mt
    />
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import { useGalleryImages } from '@/helpers/imaginary/gallery-images';
import unleash from '@/unleash';

const props = defineProps<{
  modelValue: string[];
}>();

const emit =
  defineEmits<(event: 'update:modelValue', value: string[]) => void>();

const imaginaryCategory = computed(() =>
  unleash.isEnabled('ImaginaryUploads') ? 'portfolio' : undefined,
);

const uploadError = ref<Error | null>(null);

const galleryImages = useGalleryImages(
  () => props.modelValue,
  (images) => {
    emit('update:modelValue', images);
  },
);

const clearUploadError = () => {
  uploadError.value = null;
};

const handleUploadError = (error: Error) => {
  uploadError.value = error;
};
</script>
